module.exports = __webpack_public_path__ + "media/images/alteryx-homepage-alt-1a78441b49f33c2a29e056afca3b4908f662dc0c4e47be0e0f503aac80836ba5.jpg";